import {
  Center,
  Icon,
  IconButton,
  IconName,
  Paragraph,
  Tooltip,
  message
} from '@payflip/ui/v2';
import { useImpersonatedUserQuery } from './queries.generated';
import { useImpersonateLocales } from './use-impersonate-locales';
import { useStopEmployeeImpersonation } from './use-stop-employee-impersonation';

export function ImpersonateBanner(): JSX.Element | null {
  const { data, loading: loadingUser } = useImpersonatedUserQuery();
  const { loading, stopEmployeeImpersonation } = useStopEmployeeImpersonation({
    companyId: data?.company.id as string,
    employeeId: data?.employee.id as string
  });
  const cms = useImpersonateLocales();
  const displayImpersonateBanner = !loadingUser && data?.user?.isImpersonated;

  return displayImpersonateBanner ? (
    <Center
      alignItems="center"
      bg="palette_alert.100"
      color="palette_white"
      h="space_unit.x6"
    >
      <Paragraph mx="space_unit.x2" fontSize="md">
        {message(
          cms?.impersonateBanner,
          'Currently impersonating {{firstname}} {{lastname}}',
          {
            firstname: data.user.firstname,
            lastname: data.user.lastname
          }
        )}
      </Paragraph>
      <Tooltip label={message(cms?.impersonateStop, 'Stop')}>
        <IconButton
          border="none"
          variant="unstyled"
          aria-label={message(cms?.impersonateStop, 'Stop Impersonating')}
          icon={<Icon name={IconName.SignOut} w="20px" h="20px" />}
          isDisabled={loading}
          onClick={() => {
            stopEmployeeImpersonation();
          }}
        />
      </Tooltip>
    </Center>
  ) : null;
}
